const comments = [
  {
    avatar: '匿',
    name: '老读者小陈',
    time: '2小时前',
    content: '从汗汗漫画时代追到现在，虫虫漫画的韩漫资源真的太全了，每天更新也很稳定，下拉式阅读体验超赞！',
    likes: 328,
    tag: '韩漫粉丝',
  },
  {
    avatar: '匿',
    name: '日漫爱好者',
    time: '5小时前',
    content: '找了好久的完结日漫终于在这里看到了，画质清晰加载快，不用注册就能看全集，良心平台！',
    likes: 256,
    tag: '日漫经典',
  },
  {
    avatar: '匿',
    name: '国漫新粉',
    time: '8小时前',
    content: '朋友推荐来的，说是虫虫汗汗老站改名了。国漫区最近上了好多新作，每部都好看，入坑不亏。',
    likes: 189,
    tag: '国漫推荐',
  },
  {
    avatar: '匿',
    name: '深夜追漫人',
    time: '12小时前',
    content: '半夜刷到虫虫漫画，一口气看了十几话。界面简洁没有弹窗广告，下拉就能一直看，比好多App都好用。',
    likes: 412,
    tag: '阅读体验',
  },
  {
    avatar: '匿',
    name: '漫画老司机',
    time: '1天前',
    content: '作为看了十几年漫画的老读者，虫虫漫画的更新速度和内容质量确实不错。韩漫日漫国漫一站搞定，不用到处找了。',
    likes: 275,
    tag: '资深漫友',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            读者热评
          </h2>
          <p className="text-sm text-foreground-500">虫虫漫画读者真实反馈，听听漫友们在聊什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{comment.name}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">
                "{comment.content}"
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-primary-500"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}